module.exports = __webpack_public_path__ + "img/logo-f3.6c643c2f.png";